"use strict";
angular.module('appMarketplace')
    .controller('HeaderCtrl', ['$scope', '$state', '$timeout', '$filter', 'UrlService', 'NavigationService', 'navigationStyle',
                              'CommonService', 'UserService',
                              function ($scope, $state, $timeout, $filter, UrlService, NavigationService, navigationStyle,
                                        CommonService, UserService) {
        var PAGES_WITH_DOCUMENT_ID = [
            '/catalogue-search.html',
            '/punch-out-suppliers.html',
            '/supplier-directory.html',
            '/quick-add.html'
        ];
        var CATALOGUE_GROUP_ID = 2;
        var DELTA = 50;
        var MIN_WINDOW_WIDTH = 600;
        
        $scope.documentId = UrlService.getURLParameter('DocumentId');

        var mainMenuWrapper;
        var collapsedMenuWrapper;
        var menu = angular.element('#menuHeaderContainer');

        function initMenu() {
            mainMenuWrapper = function () {
                var element = angular.element("#mainMenu");
                return {
                    makeVisible: function () {
                        element.css("visibility", "visible");
                    },
                    getVisibleItems: function () {
                        return element.find("> li:visible");
                    },
                    getHiddenItems: function () {
                        return element.find("> li.k-item:hidden");
                    }
                };
            }();

            collapsedMenuWrapper = function () {
                var element = angular.element("#collapsedMenu");
                return {
                    element: element,
                    makeVisible: function () {
                        element.css("visibility", "visible");
                    },
                    show: function () {
                        element.css("display", "inline-block");
                    },
                    hide: function () {
                        element.hide();
                    },
                    getVisibleItems: function () {
                        return element.find("li.k-item.nav-group:not(.hidden-item)");
                    },
                    getHiddenItems: function () {
                        return element.find("li.k-item.hidden-item");
                    },
                    showLastHiddenItem: function () {
                        this.getHiddenItems().last().toggleClass("hidden-item");
                    }
                };
            }();
            collapsedMenuWrapper.element.find("> li > ul > li.k-item").toggleClass('hidden-item'); //hide all items
            resizeMenu();
            mainMenuWrapper.makeVisible();
            collapsedMenuWrapper.makeVisible();
        }

        CommonService.showProgressPanel(menu, false);
        NavigationService.getNavigationData(function successCallback(value) {
            changeUrl(value);    // works for PAGES_WITH_DOCUMENT_ID when came from order variation

            var collapsedGroupsTitle = "More";
            var collapsedGroups = {
                text: '<span class="' + navigationStyle[collapsedGroupsTitle] + ' nav-group-icon"></span>' + collapsedGroupsTitle,
                items: value,
                encoded: false
            };

            $scope.mainMenuDS = value;
            onMenuInitialized('mainMenu');

            $scope.collapsedMenuDS = collapsedGroups;
            onMenuInitialized('collapsedMenu');

            CommonService.hideProgressPanel(menu);
            $timeout(initMenu);
        });

        function changeUrl(value) {
            angular.forEach(PAGES_WITH_DOCUMENT_ID, function pagesIterator(page) {
                if (UrlService.checkUrlContains(page) && $scope.documentId) {
                    changePagesUrl(value);
                }
            });
        }

        function changePagesUrl(value) {
            angular.forEach(value, function menuIterator(group) {
                if (group.id === CATALOGUE_GROUP_ID) {
                    angular.forEach(group.items, function groupIterator(item) {
                        if (PAGES_WITH_DOCUMENT_ID.some(function urlContainsPage(page) {
                                return item.url.indexOf(page) !== -1;
                            })) {
                            item.url += '?DocumentId=' + $scope.documentId;
                        }
                    })
                }
            })
        }

        $scope.getBasketTooltipMessage = function (basketSize, basketNetTotal) {
            return basketSize
                + " item"
                + (basketSize === 1 ? "" : "s")
                + " - "
                + $filter('currency')(basketNetTotal.value, basketNetTotal.currency.currencySymbol, 2);
        };

        $scope.logoutUrl = UrlService.createAbsoluteUrl('/useradmin/logout.jsp');

        UserService.showRequiredFormIfAnyNeeded();

        NavigationService.getCurrentAccount(function successCallback(currentAccount) {
            $scope.currentAccount = currentAccount;

            $scope.isBasketAvailable = currentAccount.basketAvailable;
            if ($scope.isBasketAvailable) {
                $scope.basketUrl = UrlService.createAbsoluteUrl('/page/basket.html');
                $scope.basketTooltip = kendo.template(angular.element("#basketTooltipTemplate").html());
            }

            $scope.isSavedBasketsAvailable = currentAccount.savedBasketsAvailable;
            if ($scope.isSavedBasketsAvailable) {
                $scope.savedBasketsUrl = UrlService.createAbsoluteUrl('/page/basket/saved-baskets.html');
            }

            $scope.userAccountMenuDS = NavigationService.getUserAccountMenu(currentAccount);
            onMenuInitialized('userAccountMenu');

            $scope.helpMenuDS = NavigationService.getHelpMenu(currentAccount);
            onMenuInitialized('helpMenu');
        });

        $scope.quickLinksMenuDS = NavigationService.getQuickLinksMenu();
        onMenuInitialized('quickLinksMenu');

        $scope.selectMenu = function(e) {
            if(angular.element(e.item).attr("openInNewWindow") === 'true') {
                e.preventDefault();
                window.open(angular.element(e.item).find("a").attr("href"), '_blank');
            }
        };

        function getWrappersDistance() {
            var navigationWrapper = angular.element("#navigationWrapper");
            var navigationRightEdgeX = navigationWrapper.offset().left + navigationWrapper.width(); //should be zero + width
            var actionsWrapper = angular.element("#actionsWrapper");
            return actionsWrapper.offset().left - navigationRightEdgeX;
        }

        function collapseMenu() {
            mainMenuWrapper.getVisibleItems().last().hide();
            collapsedMenuWrapper.show();
            collapsedMenuWrapper.showLastHiddenItem();
        }

        function expandMenu() {
            mainMenuWrapper.getHiddenItems().first().show();
            var visibleCollapsedItems = collapsedMenuWrapper.getVisibleItems();
            visibleCollapsedItems.first().toggleClass("hidden-item");
            if (visibleCollapsedItems.length <= 1) {
                collapsedMenuWrapper.hide();
            }
        }

        function collapseNeeded() {
            return window.innerWidth > MIN_WINDOW_WIDTH && getWrappersDistance() < DELTA;
        }

        function expandNeeded() {
            return mainMenuWrapper.getHiddenItems().length
                    && (getWrappersDistance() - mainMenuWrapper.getHiddenItems().last().width() >= DELTA);
        }

        function resizeMenu() {
            if (mainMenuWrapper) {
                while (collapseNeeded()) {
                    collapseMenu();
                }

                while (expandNeeded()) {
                    expandMenu();
                }
            }
        }

        function onMenuInitialized(menuName) {
            $timeout(function () {
                $scope.$emit('domChanged', $scope[menuName].element);
            });
        }

        function closeMenu(menu) {
            if (menu) {
                menu.close(".k-item");
            }
        }

        angular.element(document).on('mouseleave', function onMouseLeave() {
            closeMenu($scope.mainMenu);
            closeMenu($scope.collapsedMenu);
            closeMenu($scope.userAccountMenu);
            closeMenu($scope.helpMenu);
            closeMenu($scope.quickLinksMenu);
        });

        var resizeTimer;
        angular.element(window).on('resize', function onResize() {
            $timeout.cancel(resizeTimer);
            resizeTimer = $timeout(resizeMenu, 100);
        });
    }]);



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/controllers/header-ctrl.js
// module id = 236
// module chunks = 17